import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";
import { employeeApi } from "store/reducers";
import { RootState } from "store/store";

import { certificateApi } from "./certificateAPI";

export const certificateAdapter = createEntityAdapter<Certificate>();
const initialCertificateState = certificateAdapter.getInitialState();

const certificateSlice = createSlice({
  name: "certificate",
  initialState: initialCertificateState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(certificateApi.endpoints.createCertificate.matchFulfilled, (state, action) => {
        certificateAdapter.addOne(state, action.payload);
      })
      .addMatcher(certificateApi.endpoints.deleteCertificate.matchFulfilled, (state, action) => {
        certificateAdapter.removeOne(state, action.meta.arg.originalArgs.certificate_id);
      })
      .addMatcher(employeeApi.endpoints.fetchEmployees.matchFulfilled, (state, action) => {
        certificateAdapter.upsertMany(state, action.payload.certificates);
      });
  },
});

export { certificateSlice };
export const {
  selectById: selectCertificateById,
  selectAll: selectAllCertificates,
  selectEntities: selectCertificateEntities,
} = certificateAdapter.getSelectors((state: RootState) => state.certificate);
